import React, { FunctionComponent } from 'react'
import { Container, Row } from '@paypalcorp/pp-react'
import clx from 'classnames'
import { Link } from 'gatsby'

import CourseCardStack from './CourseCardStack'
import { Video } from '../utils/common'
import { VIDEO_BASE_PATH } from '../constants'

interface VideoRowProps {
  title: string
  videos: Video[]
  altBackground?: boolean
  viewAllUrl?: string
  videosCount?: number
  dataTestid?: string
}

export const VideoRow: FunctionComponent<VideoRowProps> = ({
  title,
  videos,
  altBackground = false,
  viewAllUrl,
  videosCount = 1,
  dataTestid,
}) => (
  <Row
    className={clx('videoRow', {
      'videoRow-altBackground': altBackground,
    })}
    data-testid={dataTestid ?? 'video-row'}
  >
    <Container style={{ width: '100%' }}>
      <div className="videoRow-titleRow">
        <h2 data-testid="title">{title}</h2>
        {viewAllUrl ? (
          <a
            href={viewAllUrl}
            style={{ fontWeight: 700 }}
            data-testid="view-all-link"
          >
            View All
          </a>
        ) : null}
      </div>
      <div id="videoRow" className="videoRow-mainRow">
        {videos.map(({ id, title, thumbnails, duration }) => (
          <div className="videoRow-card" key={title}>
            <CourseCardStack
              title={title}
              videos={videosCount}
              duration={duration}
              thumbnail={thumbnails.high.url}
              link={`${VIDEO_BASE_PATH}/watch?videoId=${id}`}
            />
          </div>
        ))}
      </div>
    </Container>
  </Row>
)
